<template>
  <b-card>
    <div class="row mb-3 mt-3 align-items-center">
      <div class="col-md-4">
        <div class="form-group">
          <input
            type="number"
            max="100"
            min="0"
            class="form-control"
            v-model="percentageOfPass"
            @input="percentageOfPassChange()"
          />
        </div>
      </div>
      <div class="col-md-5">
        <div class="form-group">
          <input
            type="text"
            name="users"
            class="form-control"
            v-model="search"
            autocomplete="off"
            readonly
            onfocus="this.removeAttribute('readonly');"
            @input="(val) => searchChange(val)"
            :placeholder="$t(`site.search`)"
          />
        </div>
      </div>
      <div class="col-md-3">
        <div class="float-md-right pt-1">
          <span class="text-muted text-small mr-1 mb-2">
            {{ from }}:{{ to }}
          </span>

          <b-dropdown
            id="ddown2"
            right
            :text="`${perPage}`"
            variant="outline-warning"
            size="xs"
          >
            <b-dropdown-item
              v-for="(size, index) in [5, 10, 20, 50, 100]"
              :key="index"
              @click="changePageSize(size)"
              >{{ size }}</b-dropdown-item
            >
          </b-dropdown>
          <span class="text-muted mr-1 mb-2"> of {{ total }}</span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 overflow-auto">
        <b-table
          :stacked="$mobile == 1"
          ref="table"
          class="vuetable"
          sort-by="id"
          sort-desc.sync="false"
          :current-page="currentPage"
          :fields="bootstrapTable.fields"
          :items="dataProvider"
        >
          <template #cell(code)="data"> #{{ data.item.code }} </template>
          <template #cell(activites)="data">
            <b-button variant="primary" v-b-modal="'modal-'+data.item.code">
              <b-modal size="xl" :id="'modal-'+data.item.code" centered>
                <b-col lg="12">
                 <b-table
                 :fields="adjust_fields(data.item)"
                 :items="[data.item]"

                 >
                 
                </b-table>
                </b-col>
              </b-modal>
            عرض الأنشطة</b-button
            >
          </template>
        </b-table>
        <b-spinner v-if="load" type="grow" label="Loading..." class="loading" />

        <hr />

        <b-pagination
          v-model="currentPage"
          align="right"
          class="dataTables_paginate paging_simple_numbers pagination-warning"
          :total-rows="totalRows"
          :per-page="perPage"
        >
          <template v-slot:next-text>
            <i class="fas fa-angle-left" />
          </template>
          <template v-slot:prev-text>
            <i class="fas fa-angle-right" />
          </template>
          <template v-slot:first-text>
            <i class="fas fa-step-forward" />
          </template>
          <template v-slot:last-text>
            <i class="fas fa-step-backward" />
          </template>
        </b-pagination>
        <!-- end of table -->
      </div>
      <!-- end of col -->
    </div>
    <!-- end of row -->
  </b-card>
</template>

<script>
import controller from "@/Controllers/ActivityUserAnswerController";
import ActivitiesController from "@/Controllers/ActivitiesController";
import vSelect from "vue-select";
import EduCoursesController from "@/Controllers/EduCoursesController";
import Auth from "@/Apis/Auth";

export default {
  props: ["items", "editItem"],
  components: {
    vSelect,
  },
  data() {
    return {
      bootstrapTable: {
        selected: [],
        selectMode: "multi",
        fields: [
          {
            key: "code",
            label: this.$i18n.t("students.academic_number"),
            sortable: true,
          },
          {
            key: "full_name",
            label: this.$i18n.t("students.full_name"),
            sortable: true,
          },

          {
            key: "email",
            label: this.$i18n.t("users.email"),
            sortable: true,
          },
          {
            key: "activites",
            label: "الأنشطة",
          },
        ],
      },
      data: [],
      selectAll: false,
      currentPage: 1,
      select: [],
      page: 1,
      perPage: 5,
      search: "",
      from: 0,
      total: 0,
      totalRows: 0,
      to: 0,
      lastPage: 0,
      load: false,
      apiParams: {},
      params: {},
      recordIds: [],
      user: {},
      eduPrograms: [],
      activityFields: [],
      edu_courses: [],
      edu_course: 0,
      percentageOfPass: 65,
    };
  },
  async created() {},
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    percentageOfPassChange() {
      if (this.percentageOfPass == 0 && this.percentageOfPass > 90) return;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    async dataProvider(ctx) {
      this.load = true;
      this.params = ctx;
      this.activity = await new ActivitiesController().GetAll({
        with: ["questions.user_answers"],
        filter: "edu_course_id|" + this.$route.params.id,
        all: 1,
      });
      // await this.activity.forEach((element) => {
      //   //check if it contains user answers
      //   console.log(element);
      //   this.activityFields.push({
      //     key: "activity" + element.id,
      //     label: element.name,
      //     sortable: false,
      //   });
      // });
      // this.bootstrapTable.fields.push(...this.activityFields);
      // this.bootstrapTable.fields.push({
      //   key: "total",
      //   label: "total",
      //   sortable: false,
      // });
      // this.bootstrapTable.fields.push({
      //   key: "result",
      //   label: "نتيجة",
      //   sortable: false,
      // });
      const data = await new controller().report(this.apiParamsConverter());
      this.data = this.setData(data.data);

      this.currentPage = data.current_page;
      this.perPage = data.per_page;
      this.totalRows = data.total;
      this.from = data.from;
      this.to = data.to;
      this.total = data.total;
      this.load = false;
      return data.data;
    },
    setData(data) {
      for (let index = 0; index < data.length; index++) {
        const user = data[index];
        let total = 0;
        let activityTotal = 0;
       // console.log(this.activity);
        this.activity.forEach((activity) => {
          if (activity.type == "homework" || activity.type == "exam") {
            const answers = [];
            activity.questions.forEach((question) => {
              question.user_answers.forEach((user_answer) => {
                if (user_answer.user_id == user.id) {
                  answers.push(user_answer);
                }
              });
            });
            let max = "-";
            if (answers.length > 0)
              max = this.best_grade(activity.grade, answers);
           // console.log(this.best_grade(activity.grade, answers));
            if (max != "-") total += max;
            activityTotal += 100;
            user["activity" + activity.id] = "(" + max + " / " + activity.grade  + ") " +((max/activity.grade)*100).toFixed(2) + "%";
          } else {
            activity.questions.forEach((question) => {
              const answer = question.user_answers.filter(
                (a) => a.user_id == user.id
              );
              let max = "-";
              let answer_grade = 0;
              if (answer.length > 0) {
                const ans = answer.reduce((prev, current) =>
                  prev.grade > current.grade ? prev : current
                );
                max = ans.grade;
                
                total += max;
                activityTotal += 100;
                answer_grade =  this.best_grade(activity.grade, answer);

              }
            
              user["activity" + activity.id] = "(" + answer_grade + " / " + activity.grade   + ") " +((answer_grade/activity.grade)*100).toFixed(2) + "%";
            });
          }
        });
        user["total"] = total.toFixed(0) + " / " + activityTotal;
        let pass = "راسب ";

        if (total / activityTotal >= this.percentageOfPass / 100) {
          pass = "ناجح";
        }
        user["result"] = pass;
      }
    },
    adjust_fields(item){
      let fields = [];
      //console.log(item);
      //iterate object and find keys that contain activity
      for (const key in item) {
        let user_id = item.id;
        if (key.includes("activity")) {
          //get the name from this.activity using id that exists in key
          let id = key.replace("activity", "");
          let activity = this.activity.find((element) => element.id == id);
          //check if it contains user answers
          let user_answers = activity.questions
            .map((element) => element.user_answers)
            .flat();
          let answers = user_answers.filter(
            (element) => element.user_id == user_id
          );
          if(answers.length == 0) continue;
          //check if answer is not empty or null
         // console.log(answers);
          let label = activity.name;
          fields.push({
            key: key,
            label: label,
            sortable: false,
          });
        }
     
      }
      return fields;
    },
    best_grade(activity_grade, answers) {
      //console.log(answers);
      //console.log(activity_grade);
      let grades = [];
      for (let i = 1; i <= 3; i++) {
        let correct_flag = 0;
        let mygrade = 0;
        const results = answers.filter((element) => {
          return element.answer_number == i;
        });
        if (results.length > 0) {
          results.map((el) => {
            if (el.grade != null) {
              correct_flag = 1;
              mygrade += el.grade;
            }
          });
          //console.log(mygrade);
          grades.push(
            correct_flag == 0
              ? null
              : ((mygrade / results.length) * (activity_grade / 100)).toFixed(2)
          );
        }
      }
      if (grades.every((element) => element === null)) {
        return "-";
      }
      return Math.max(...grades);
    },
    apiParamsConverter() {
      let apiParams = { per_page: this.perPage };
      if (this.params.currentPage >= 1) {
        apiParams.page = this.params.currentPage;
      }
      if (this.params.sortBy && this.params.sortBy.length > 0) {
        apiParams.sort = `${this.params.sortBy}|${
          this.params.sortDesc ? "desc" : "asc"
        }`;
      }
      if (this.params.filter && this.params.filter.length > 0) {
        // Optional
      }
      if (this.search !== "") {
        apiParams.search = this.search;
      }

      apiParams.edu_course_id = this.$route.params.id;
      return apiParams;
    },
    changePageSize(perPage) {
      this.page = 1;
      this.perPage = perPage;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },

    getFieldText(item) {
      return item.code + " " + item.name;
    },
    searchChange() {
      if (this.search.length == 0) {
        this.dataProvider(this.params);
        this.$refs.table.refresh();
      }
      if (this.search.length < 2) return;
      this.page = 1;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
